// @flow
import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import Glyph from 'components/Glyph';
import Heading from 'components/Heading';
import Link from 'components/Link';
import List from 'components/List';
import ListItem from 'components/ListItem';
import Text from 'components/Text';

import type { SearchForFamilyMembers_potentialFamily } from '../queries/__generated__/SearchForFamilyMembers';

type Props = {
  allowDirectAdd: boolean,
  isMinQueryLength: boolean,
  onSelectFamilyMember: (familyMember: *) => void,
  onDirectAddClick: (query: string) => void,
  onQueryChange: (query: string) => void,

  // data from parent container component
  loading: boolean,
  familyMembers: SearchForFamilyMembers_potentialFamily[],
};

type State = {
  selectedFamilyMember: *,
  query: string,
};

export default class FamilyTypeaheadInput extends React.Component<Props, State> {
  state = {
    selectedFamilyMember: false,
    query: '',
  };

  handleQueryChange = (query: string) => {
    this.props.onQueryChange(query);
    this.setState({ query });
  };

  handleQueryClear = () => {
    this.props.onQueryChange('');
    this.setState({ query: '', selectedFamilyMember: null });
  };

  handleSelection = (familyMemberUser: *) => {
    this.props.onSelectFamilyMember(familyMemberUser);
    this.setState({ selectedFamilyMember: familyMemberUser });
  };

  renderResultList = (props: Props) => {
    if (props.loading) {
      return (
        <List>
          <ListItem className="AdminTeacherTypeahead-results-item">
            <CenteredLoadingIndicator />
          </ListItem>
        </List>
      );
    }

    return (
      <List>
        {props.familyMembers.length ? (
          props.familyMembers.map(familyMember =>
            this.renderFamilyMemberListItem(familyMember.user)
          )
        ) : (
          <ListItem className="AdminTeacherTypeahead-results-item">
            <Heading level="6" flush data-test="no-results-text">
              No results
            </Heading>
          </ListItem>
        )}
        {this.props.allowDirectAdd && (
          <ListItem className="AdminTeacherTypeahead-results-item AdminTeacherTypeahead-results-item--link">
            <Link
              block
              onClick={() => this.props.onDirectAddClick(this.state.query)}
              data-test="add-person-link">
              <Text size="xxsmall">Add parent or guardian to Remind</Text>
            </Link>
          </ListItem>
        )}
      </List>
    );
  };

  renderFamilyMemberListItem = (familyMemberUser: *) => {
    return (
      <ListItem
        key={familyMemberUser.uuid}
        className="AdminTeacherTypeahead-results-item AdminTeacherTypeahead-results-item--link">
        <Link block color="graphite" onClick={() => this.handleSelection(familyMemberUser)}>
          {familyMemberUser.firstName} {familyMemberUser.lastName}
        </Link>
      </ListItem>
    );
  };

  render() {
    const closeButton = (
      <Button aria-label="Close" level="icon" onClick={this.handleQueryClear}>
        <Glyph name="close" size="small" solo />
      </Button>
    );
    const { selectedFamilyMember, query } = this.state;

    return (
      <div className="AdminTeacherTypeahead-inputWrap">
        <FormElement
          label="Full name"
          onValidChange={e => this.handleQueryChange(e.target.value)}
          element={Input}
          elementProps={{
            value:
              selectedFamilyMember &&
              selectedFamilyMember.firstName &&
              selectedFamilyMember.lastName
                ? `${selectedFamilyMember.firstName} ${selectedFamilyMember.lastName}`
                : query,
            placeholder: 'Search by first or last name',
            append: selectedFamilyMember && closeButton,
          }}
        />
        {!selectedFamilyMember && this.props.isMinQueryLength && (
          <div className="AdminTeacherTypeahead-dropdown">{this.renderResultList(this.props)}</div>
        )}
      </div>
    );
  }
}
